<p class="question">{{question.question}}</p>
<dx-radio-group
    id="radio-group-with-selection"
    [items]="question.options"
    (onValueChanged)="onRadioValueChanged($event)"
    displayExpr="option"
>
</dx-radio-group>
